import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	invalidDate: {
		id: 'backlog.card-list.hooks.use-format-date.invalid-date',
		defaultMessage: 'Invalid date',
		description: 'Fallback text for an invalid date being parsed',
	},
});
